module.exports = __webpack_public_path__ + "images/FUSA_icons/076-package-1.fd84348ae0be9bf9996ad467f5299707.svg";